import { useQuery } from "@tanstack/react-query"

import { OrganizationsResponses } from "@tfg/types/endpoints/organizations"

import { httpClient } from "~/backend/axios.ts"

export const useGetOrganizationSettingsQuery = (organizationId?: string) => {
  const fetchAllOrganizationSettings = async (organizationId: string) => {
    const [organization, subscriptionPlan] = await Promise.all([
      httpClient
        .get<
          Omit<OrganizationsResponses.Organization, "users">
        >(`/organizations/${organizationId}/settings/`)
        .then((response) => response.data),
      httpClient
        .get<{
          subscriptionPlan: OrganizationsResponses.OrganizationSettings["subscriptionPlan"]
        }>(`/v1/organization-settings/get-subscription-plan/${organizationId}`)
        .then((response) => response.data.subscriptionPlan),
    ])

    return {
      ...organization,
      settings: {
        ...organization.settings,
        subscriptionPlan,
      },
    }
  }

  return useQuery({
    queryKey: ["allOrganizationSettings", organizationId],
    enabled: !!organizationId,
    queryFn: () => fetchAllOrganizationSettings(organizationId!),
  })
}
